<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Registrar Empresa
            <router-link :to="{ name: 'Empresas' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.nombreEmpresa.$model"
                  :isValid="checkIfValid('nombreEmpresa')"
                  label="Nombre de la empresa:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 2 caracteres y maximo 100 caracteres"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.razonSocial.$model"
                  :isValid="checkIfValid('razonSocial')"
                  label="Razón social:"
                  placeholder="Razón social..."
                  invalidFeedback="Campo requerido, debe tener al menos 2 caracteres y maximo 100 caracteres"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.rfc.$model"
                  :isValid="checkIfValid('rfc')"
                  label="RFC:"
                  placeholder="RFC..."
                  invalidFeedback="Campo requerido, debe tener al menos 2 caracteres y maximo 20 caracteres"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.registroPatronal.$model"
                  :isValid="checkIfValid('registroPatronal')"
                  label="Registro patronal:"
                  placeholder="Registro patronal..."
                  invalidFeedback="Campo requerido, debe tener al menos 2 caracteres y maximo 20 caracteres"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <input
                  ref="imgTr"
                  @change="inputFile"
                  type="file"
                  label="Unidad extra:"
                  placeholder="Image..."
                />
              </CCol>
            </CRow>

            <img v-show="url" class="mt-2" width="50" height="50" :src="url" :alt="urlName" />

            <ExtraConfigInput
              title="de la empresa"
              parametro="empresas_atributos_extras"
              v-model="fieldsExtra"
              @config="config => fieldsExtraConfig = config"
              @onValid="v=>valid=v"
            />
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CAlert
                  fade
                  color="success"
                  class="my-1"
                  :show.sync="currentAlertCounter"
                >Guardado con éxito.</CAlert>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Empresas' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>

            <CButton @click="addEmpresa()" class="px-4 mx-3 btn-lg" color="success">
              <div v-if="isLoading">
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>

      <CModal
        size="sm"
        title="Empresa"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >{{ error }}</CModal>
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import ExtraConfigInput from './../../customComponents/ExtraConfigInput.vue'
import "vue-select/dist/vue-select.css";

export default {
  name: "NuevoEmpresa",

  components: {
    ExtraConfigInput
  },

  computed: {
    isValidEmpresa() {
      return !this.$v.nombreEmpresa.$invalid;
    },
    isValidRazonSocial() {
      return !this.$v.razonSocial.$invalid;
    },
    isValidRfc() {
      return !this.$v.rfc.$invalid;
    },
    isValidRegistroPatronal() {
      return !this.$v.registroPatronal.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  methods: {
    inputFile(e) {
      let reader = new FileReader();
      this.url = "";
      this.urlName = "";

      reader.onload = file => {
        this.url = file.target.result;
        this.urlName = e.target.files[0].name;
      };

      reader.readAsDataURL(e.target.files[0]);
      //  this.$emit('input', this.value);
    },
    addEmpresa() {
      this.validateEmpresa();

      if(!this.valid.flag){
        const valores = this.valid.valores
        this.error = `Son requeridos los campos: ${valores.join(', ')}`;
        this.warningModal=true
        return
      }
      if (
        this.isValidEmpresa &&
        this.isValidRazonSocial &&
        this.isValidRfc &&
        this.isValidRegistroPatronal
      ) {
        this.isLoading = true;
        
        this.fieldsExtraConfig.forEach(indexField => {
          if (indexField.tipo === "number") {
            this.fieldsExtra[indexField.nombre] =
              Number(this.fieldsExtra[indexField.nombre]) || 0;
          }
          if (indexField.tipo === "text") {
            this.fieldsExtra[indexField.nombre] =
              this.fieldsExtra[indexField.nombre] || "";
          }
        });
        const agregarEmpresa = {
          schema: "empresas",
          payload: {
            nombre: this.nombreEmpresa,
            razon_social: this.razonSocial,
            rfc: this.rfc,
            registro_patronal: this.registroPatronal,
          }
        }
        if (this.fieldsExtraConfig.length > 0) {
          agregarEmpresa.payload.extras = this.fieldsExtra;
        }
        let img = this.$refs.imgTr;
        console.log(this.isLoading);
        if (img.files[0]) {
          let formData = new FormData();
          formData.append("media", img.files[0]);

          this.$store
            .dispatch("customImageHTTP", formData)
            .then(res => {
              console.log(res.data);
              agregarEmpresa.payload.fotografia = res.data
              this.addEmpresaFull(agregarEmpresa);
            })
            .catch(rej => {
              console.log(rej);
            });
        } else {
          this.$store
            .dispatch("customActualizarHTTP", agregarEmpresa)
            .then(() => {
              this.currentAlertCounter = 6;
            })
            .catch(rej => {
              // console.log(rej);
              this.error = rej.message;
              this.warningModal = true;
            })

            .finally(() => {
              this.isLoading = false;
            });
        }
      }
    },
    addEmpresaFull(agregarEmpresa) {
      this.isLoading = true;
        
      this.$store
        .dispatch("customActualizarHTTP", agregarEmpresa)
        .then(() => {
          this.currentAlertCounter = 6;
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.isLoading = false;
        });
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateEmpresa() {
      this.$v.nombreEmpresa.$touch();
      this.$v.razonSocial.$touch();
      this.$v.rfc.$touch();
      this.$v.registroPatronal.$touch();
      // this.$v.equivalencia_6oz.$touch();
    }
  },

  created() {},

  mixins: [validationMixin],
  validations: {
    nombreEmpresa: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(100)
    },

    razonSocial: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(100)
    },

    rfc: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(20)
    },

    registroPatronal: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(20)
    }
  },

  data() {
    return {
      nombreEmpresa: "",
      razonSocial: "",
      rfc: "",
      registroPatronal: "",
      url: "",
      urlName: "",
      warningModal: false,
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      error: "",
      fieldsExtraConfig: [],
      fieldsExtra: {},
      valid: {flag: true}
    };
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  width: 100%;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
